export const formattingTime = (seconds: number): string => {
  if (isNaN(seconds)) {
    return '00:00'
  }

  const date = new Date(seconds * 1000)
  const mm = date.getUTCMinutes().toString().padStart(2, '0')
  const ss = date.getUTCSeconds().toString().padStart(2, '0')

  return `${mm}:${ss}`
}
